import { trackEvent, SegmentEvents } from '@nile/mantine-theme/analytics'
import { extractErrorDetails } from './extractErrorDetails'
import { redactDocusignUrls } from './analytics/docusignTelemetryScrub'

export type ClientErrorSource =
    | 'global_error_boundary'
    | 'route_error_boundary'
    | 'window_onerror'
    | 'unhandled_rejection'

interface TrackClientErrorParams {
    error: unknown
    source: ClientErrorSource
    componentStack?: string | null
}

export function trackClientError({ error, source, componentStack }: TrackClientErrorParams) {
    try {
        const details = extractErrorDetails(error, { maxStackLength: 512 })

        // ResizeObserver noise (browser internals, not actionable) — same filter as Datadog RUM.
        if (details.message.indexOf('ResizeObserver loop') !== -1) {
            return
        }

        trackEvent(SegmentEvents.CLIENT_ERROR, {
            error_name: details.name,
            // DocuSign signing URLs are session credentials and must never reach analytics.
            error_message: redactDocusignUrls(details.message).substring(0, 500),
            error_stack: details.stack && redactDocusignUrls(details.stack),
            source,
            page: typeof window !== 'undefined' ? window.location.pathname : 'unknown',
            url: typeof window !== 'undefined' ? window.location.href : 'unknown',
            ...(componentStack && { component_stack: componentStack.substring(0, 512) }),
        })
    } catch {
        // Never let error tracking itself cause user-facing errors
    }
}
